/* eslint-disable react/require-default-props */
import React from 'react';

import AiLoadingText from 'components/atoms/ai_loading_text';

import type { CustomAnalysisPrompt } from 'hooks/useCustomAnalysisPrompt';

import iconRobotIa from 'assets/images/icon_robot_ia.svg';

import { ButtonContainer, Container } from './styles';

export const CUSTOMIZE_ANALYSIS_LABEL = 'Personalizar sua análise';

const LOADING_MESSAGES = [
  'Carregando sua análise personalizada',
  'Buscando suas instruções',
  'Preparando os destaques da sua empresa',
  'Quase lá',
];

interface CustomizeAnalysisButtonProps {
  onClick: () => void;
  className?: string;
}

export const CustomizeAnalysisButton: React.FC<CustomizeAnalysisButtonProps> = ({
  onClick,
  className = '',
}) => (
  <ButtonContainer
    type="button"
    className={`btn btn-outline-primary btn-outline-ia d-inline-flex align-items-center ${className}`.trim()}
    onClick={onClick}
  >
    <img src={iconRobotIa} alt="" aria-hidden className="customize-analysis-icon" />
    <span className="span-outline-ia">{CUSTOMIZE_ANALYSIS_LABEL}</span>
  </ButtonContainer>
);
interface BiddingSummaryCustomAnalysisProps {
  prompt: CustomAnalysisPrompt | null;
  isLoading?: boolean;
  hasError?: boolean;
  onCustomize: () => void;
  isAlfaTester?: boolean;
  answer?: string | null;
  isAnswerLoading?: boolean;
  isAnswerRefreshing?: boolean;
  hasAnswerError?: boolean;
  onRefreshAnswer?: () => void;
}

const BiddingSummaryCustomAnalysis: React.FC<BiddingSummaryCustomAnalysisProps> = ({
  prompt,
  isLoading = false,
  hasError = false,
  onCustomize,
  isAlfaTester = false,
  answer = null,
  isAnswerLoading = false,
  isAnswerRefreshing = false,
  hasAnswerError = false,
  onRefreshAnswer,
}) => {
  if (isLoading) {
    return (
      <Container>
        <AiLoadingText messages={LOADING_MESSAGES} className="custom-analysis-loading" />
      </Container>
    );
  }

  if (hasError) {
    return (
      <Container>
        <div className="alert alert-warning small mb-0" role="alert">
          Não foi possível carregar a sua análise personalizada. Tente novamente mais tarde.
        </div>
      </Container>
    );
  }

  if (!prompt) {
    return (
      <Container>
        <div className="custom-analysis-empty text-center">
          <p className="custom-analysis-empty-title mb-2">
            Você ainda não tem uma análise personalizada
          </p>
          <p className="custom-analysis-empty-text mb-3 mx-auto">
            Adicione instruções para destacar os pontos mais importantes para sua empresa. O
            Analista de Editais utilizará essas informações para complementar a análise automática
            do edital.
          </p>
          <CustomizeAnalysisButton onClick={onCustomize} />
        </div>
      </Container>
    );
  }

  if (!isAlfaTester) {
    return (
      <Container>
        <p className="custom-analysis-content mb-0">{prompt.content}</p>
      </Container>
    );
  }

  return (
    <Container>
      {isAnswerLoading && (
        <p className="custom-analysis-loading mb-0">Gerando sua análise personalizada…</p>
      )}

      {!isAnswerLoading && hasAnswerError && (
        <div className="alert alert-warning small mb-0" role="alert">
          Não foi possível gerar sua análise personalizada. Tente novamente mais tarde.
        </div>
      )}

      {!isAnswerLoading && !hasAnswerError && (
        <p className="custom-analysis-content mb-0">{answer}</p>
      )}

      {!isAnswerLoading && (
        <button
          type="button"
          className="btn btn-link btn-sm custom-analysis-refresh-button px-0 mt-2"
          onClick={onRefreshAnswer}
          disabled={isAnswerRefreshing}
        >
          {isAnswerRefreshing ? 'Atualizando…' : 'Atualizar análise'}
        </button>
      )}
    </Container>
  );
};

export default BiddingSummaryCustomAnalysis;
